import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { makeTestId } from '../../utils/Declarative';
import { HexColorInput } from './HexColorInputWidget';

export interface CustomColorInputProps {
  color: string;
  onColorSelected: (color: string) => void;
  testId: string;
}

export const CustomColorInput = React.forwardRef<HTMLDivElement, CustomColorInputProps>((props, ref) =>
  <div data-tb-test-id={makeTestId(props.testId, 'CustomColorInput')} ref={ref}  >
    <HexColorInput
      color={props.color}
      label={Messages.customColor()}
      onConfirm={props.onColorSelected}
      testId={props.testId}
    />
  </div>
);
CustomColorInput.displayName = 'CustomColorInput';
